
if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueAnalytics from 'vue-analytics'
import objectFitImages from 'object-fit-images';
import Components from "./components";
import * as scrll from './funcs.js';
import inView from 'in-view';
import VueCarousel from 'vue-carousel';
import 'picturefill';
import 'lazysizes';
import './hero';
import './distributors';

Vue.use(Vuelidate);
Vue.use(VueCarousel);

new Vue({
  el: "#app",
  delimiters: ["${", "}"],
  data: {
    focusOn: false,
    stickyOn: false,
    showNav: false,
    navActive: []
  },
  methods: {

    navExpand(e, id, forceOpen) {
      if (this.navActive.includes(id)) {
        if (typeof forceOpen == 'undefined') {
          this.navActive.remove(id);
        }
      } else {
        this.navActive.push(id);
        scrll.scrollToAnchor('nav' + id, $('.nav-nav'));
      }
      this.showNav = true;
      e.preventDefault();
      return false
    },

    focusActivate(e) {
      if (e.keyCode === 9 || e.keyCode === 13) {
        this.focusOn = true;
      }
    },

    focusDeactivate(e) {
      this.focusOn = false;
    },

    handleScroll (e) {
      var scrollY = window.scrollY;
      if (scrollY > 100) {
        this.stickyOn = true;
      } else {
        this.stickyOn = false;
      }
    },

    handleResize (e) {

    }

  },
  created () {

    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

  },
  destroyed () {

    window.removeEventListener('scroll', this.handleScroll);

    window.removeEventListener('scroll', this.handleResize);

  }
});


//* objectfit polyfill =================================================== */

objectFitImages();


//* is touch device =================================================== */

var isTouch = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  isTouch = true;
}


//* breakpoints =================================================== */

function breakpointWidth(bp) {
  bpWidth = 768;
  if (bp == 'baby') {
    bpWidth = 479;
  }
  if (bp == 'teen') {
    bpWidth = 600;
  }
  if (bp == 'mama') {
    bpWidth = 768;
  }
  if (bp == 'mega') {
    bpWidth = 1279;
  }
  return bpWidth;
}

function breakpointMax(bp) {
  bpWidth = breakpointWidth(bp);
  if ($(window).width() <= bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}

function breakpointMin(bp) {
  bpWidth = breakpointWidth(bp);
  if ($(window).width() > bpWidth) {
    return true;
  } else {
    return false;
  }
  return true;
}


//* scroll to anchor =================================================== */

// all hashtags
$(document).on('click','a[href^="#"]',function(){
  var $this = $(this);
  var aId = $this.attr('href').replace('#','');;
  var $anchorElement = $('[id="' + aId + '"], [name="' + aId + '"], [data-id="' + aId + '"]');
  if ($anchorElement.length > 0) {
    scrll.scrollToAnchor(aId);
    return false;
  }
});

// scroll if hashtag
$(document).ready(function(){
  var hash = window.location.hash.replace('#', '');
  if (hash != '') {
    scrll.scrollToAnchor(hash);
  }
});


//* home page intro animation =================================================== */

inView('.s_animate').on('enter', function(el) {
  $(el).removeClass('s_animate');
});